<script setup lang="ts">
import logo from '@/assets/logo_svg_gray.svg'
</script>
<template>
  <div flex flex-row items-center pl-7.3 py-1>
    <img ml-1px w-6 h-6 :src="logo" mb-1.3 />
    <a ml-3 text-base font-bold text-lg>{{ $t('app.name') }}</a>
  </div>
</template>
<style lang="scss" scoped></style>
